import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=36a2bf92&scoped=true"
import script from "./StudentManage.vue?vue&type=script&lang=js"
export * from "./StudentManage.vue?vue&type=script&lang=js"
import style0 from "./StudentManage.vue?vue&type=style&index=0&id=36a2bf92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2bf92",
  null
  
)

export default component.exports